import type { SettingsState } from './types';
import { defaultFont } from '@/theme/core';

// ----------------------------------------------------------------------

export const STORAGE_KEY = 'app-settings';

export const defaultSettings: SettingsState = {
  colorScheme: 'light',
  direction: 'ltr',
  contrast: 'default',
  navLayout: 'vertical',
  primaryColor: 'blue',
  navColor: 'integrate',
  compactLayout: true,
  fontFamily: defaultFont,
} as const;
